import mixpanel from 'mixpanel-browser';
import store from '../reduxtoolkit/store';
import { MIX_PANEL_CODE, MIX_PANEL_ENABLED, DISABLE_ANALYTICS } from '../../constants';

function isObject(value) {
    return value && typeof value === 'object' && !Array.isArray(value);
}

// Mixpanel send Event
export const mixpanelEvent = (data) => {
    const STATIC_DISTINCT_ID = document.documentElement.getAttribute("data-mxp-id");
    const redux = store.getState();

    const { customer_code: customerCode } = redux.staticData?.data || {};

    if (!STATIC_DISTINCT_ID) {
        console.error('No static id available! ');
        return;
    }

    if (!data) {
        console.error('No data provided!');
        return;
    }
    const { eventData } = data;
    // eventData validation
    if (!isObject(eventData)) {
        console.error('eventData must be a valid object.');
        return;
    }

    if (!(
            MIX_PANEL_CODE &&
            MIX_PANEL_ENABLED === 'TRUE'
        )) {
        console.warn('analytics not enabled!');
        return;
    }

    const { event, trackingData = {} } = eventData;

    if (!isObject(trackingData)) {
        console.error('trackingData must be a valid object.');
        return;
    }

    mixpanel.track(event, {
        $device_id: STATIC_DISTINCT_ID,
        distinct_id: customerCode || STATIC_DISTINCT_ID,
        $user_id: customerCode || STATIC_DISTINCT_ID,
        ...trackingData,
    });
}

// Mixpanel register
export const mixpanelRegister = (payload) => {
    try {
        if (!(MIX_PANEL_CODE && MIX_PANEL_ENABLED === 'TRUE')) {
            console.warn('analytics not enabled!');
            return;
        }
        mixpanel.register(payload);
    } catch (error) {
        console.error('error', error);
    }
};

// Mixpanel reset
export const mixpanelReset = () => {
    try {
        if (!(MIX_PANEL_CODE && MIX_PANEL_ENABLED === 'TRUE')) {
            console.warn('analytics not enabled!');
            return;
        } 
        mixpanel.reset();
    } catch (error) {
        console.error('error', error);
    }
};